import { pipe } from "./utils"

const elementPosition = (element) => element?.position || 0
export const positionSort = (array) => array.sort((fieldA, fieldB) => elementPosition(fieldA) - elementPosition(fieldB))
const cloneObject = object => ({ ...object })

export const sortFields = formTemplate => {
  return pipe((array) => array.filter(field => !field.hidden), positionSort)(formTemplate.fields)
}

export const separateChildRecords = (childRecords) => {
  return Object.values(childRecords).reduce((acc, record) => {
    (acc[record.record_type] ??= []).push(record)
    return acc
  }, {})
}

export const mapDescendantRecords = (descendantRecords) => {
  return descendantRecords.reduce((acc, record) => {
    const { parent_uuid: parentUuid, uuid: uuid, tab_name: tabName } = record
    const key = parentUuid || tabName
    return { ...acc, [key]: { ...acc[key], [uuid]: record, }, }
  }, {})
}

export const findOrInitEntry = (field, childRecord) => {
  return childRecord?.entries.find(entry => entry.position === field.position) || {
    form_field_id: field.id,
    mobile_record_id: childRecord.id,
  }
}

export const mapToRecord = (map) => (descendantRecords) => {
  const mappedRecord = map.reduce((acc, uuid) => acc[uuid], descendantRecords)
  return { descendantRecords, mappedRecord }
}

const updateEntry = (entry) => ({ descendantRecords, mappedRecord }) => {
  const entryIndex = mappedRecord.entries.findIndex(en => en.position === entry.position)

  if (entryIndex !== -1) {
    mappedRecord.entries[entryIndex] = { ...mappedRecord.entries[entryIndex], ...entry }
  } else {
    mappedRecord.entries.push(entry)
    mappedRecord.entries = positionSort(mappedRecord.entries)
  }

  return { descendantRecords, mappedRecord }
}

const mergeRecords = ({ descendantRecords }) => descendantRecords

export const updateEntryHelper = (rootRecord, descendantRecords, entry, map) => {
  if (map.length === 0) {
    const { mappedRecord } = updateEntry(entry)({ descendantRecords: [], mappedRecord: rootRecord })
    return {
      updatedRootRecord: mappedRecord,
      updatedDescendantRecords: descendantRecords
    }
  }

  if (map.length >= 1) {
    const updatedDescendantRecords = pipe(
      cloneObject,
      mapToRecord(map),
      updateEntry(entry),
      mergeRecords,
    )(descendantRecords)

    return { updatedRootRecord: rootRecord, updatedDescendantRecords: updatedDescendantRecords }
  }
}
